import React, { useEffect, useState } from 'react'
import { uid } from '@zera-admin/utils'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Button, { ButtonGroup, LinkButton } from '@zera-admin/button'
import Page, { PageHeader, Container } from '@zera-admin/page'

import { useFlagcardContext } from 'app/contexts/flagcard'
import { ValidationError } from 'app/shared/types'
import MainLayout from 'layouts/main'
import sentimentDataSetsService, {
  SentimentDataSet,
  UpdateSentimentDataSetRequest,
} from 'services/http/dataset/sentiment-data-set'

import { UpdateSentimentDataSetProps } from './types'
import SentimentDataSetForm from './SentimentDataSetForm'

const UpdateSentimentDataSet: React.FunctionComponent<UpdateSentimentDataSetProps> =
  ({ match, history }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isReady, setIsReady] = useState(true)
    const [sentimentDataSet, setSentimentDataSet] = useState<SentimentDataSet>()
    const [flagcard] = useFlagcardContext()

    useEffect(() => {
      const id = parseInt(match.params.id)

      sentimentDataSetsService
        .getById(id)
        .then((res) => {
          setSentimentDataSet(res.data)
        })
        .catch((err: Error) => {
          console.log(err)
        })
        .finally(() => {
          setIsReady(false)
        })
    }, [match.params.id, history])

    const handleSubmit = (data: UpdateSentimentDataSetRequest) => {
      if (data) {
        setIsLoading(true)

        sentimentDataSetsService
          .update(data, parseInt(match.params.id))
          .then((response) => {
            flagcard.add({
              id: uid(),
              appearance: 'success',
              title: 'İşlem Başarılı',
              children:
                'Geçerli veri, sistem üzerinde başarıyla güncellenmiştir.',
            })

            history.push(
              match.path.replace(':id', response.data.id?.toString() || '')
            )
          })
          .catch((error) => {
            console.log(error)

            flagcard.add({
              id: uid(),
              appearance: 'error',
              title: 'Hata Oluştu',
              children:
                'Geçerli veri güncellenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
            })
          })
          .finally(() => {
            setIsLoading(false)
          })
      }
    }

    const handleError = (error?: ValidationError) => {
      console.log(error)
    }

    const breadcrumbs = (
      <Breadcrumb>
        <BreadcrumbItem text="Anasayfa" href="/" />
        <BreadcrumbItem text="Duygu veri setleri" href="/sentiment-data-set" />
        <BreadcrumbItem text="Duygu veri seti güncelle" />
      </Breadcrumb>
    )

    return (
      <MainLayout isLoading={isReady}>
        <Container width="medium">
          <Page>
            <PageHeader
              // actions={<Button appearance="error">Delete user</Button>}
              breadcrumbs={breadcrumbs}
              bottomBar={
                <p>
                  Aşağıdaki bilgileri doldurarak geçerli duygu veri setini
                  güncelleyebilirsiniz.
                </p>
              }
            >
              Veri güncelleniyor:
              {sentimentDataSet ? sentimentDataSet.text : null}
            </PageHeader>
            <SentimentDataSetForm
              actions={
                <ButtonGroup>
                  <Button
                    appearance="primary"
                    children="Güncelle"
                    isLoading={isLoading}
                    type="submit"
                  />
                  <LinkButton href="/sentiment-data-set">İptal</LinkButton>
                </ButtonGroup>
              }
              operation="update"
              onSubmit={handleSubmit}
              onError={handleError}
              values={sentimentDataSet}
            />
          </Page>
        </Container>
      </MainLayout>
    )
  }

export default UpdateSentimentDataSet
